import type { CheckDetailRow } from "@common/schemas/domains/accounting/check-detail-report.schema";

export enum CheckDetailReconciliationStatus {
    RECONCILED = "reconciled",
    UNRECONCILED = "unreconciled",
}

export type CheckDetailSectionKind = "checks" | "deposits";

export const CHECK_DETAIL_GROUP_BY_KEYS = [
    "bankAccount",
    "reconciliationStatus",
    "counterparty",
    "none",
] as const;

export type CheckDetailGroupBy = (typeof CHECK_DETAIL_GROUP_BY_KEYS)[number];

export interface CheckDetailCheckViewRow {
    id: string;
    rowKind: "check";
    check: CheckDetailRow;
    children?: undefined;
}

export interface CheckDetailGroupViewRow {
    id: string;
    rowKind: "group";
    title: string;
    total: number;
    children: CheckDetailCheckViewRow[];
}

export interface CheckDetailSectionViewRow {
    id: `section:${CheckDetailSectionKind}`;
    rowKind: "section";
    title: "Checks" | "Deposits";
    total: number;
    children: Array<CheckDetailGroupViewRow | CheckDetailCheckViewRow>;
}

export type CheckDetailViewRow =
    | CheckDetailSectionViewRow
    | CheckDetailGroupViewRow
    | CheckDetailCheckViewRow;
